import {
  AspectRatio,
  Badge,
  Box,
  HStack,
  Image,
  Link as ChakraLink,
} from "@chakra-ui/react"
import { NavigationMegaMenuCellLinkEntityHydrated } from "@jackfruit/common"
import { Link as GatsbyLink } from "gatsby"
import React, { useState } from "react"
import { usePage } from "~/hooks/usePage"

interface Props {
  link: NavigationMegaMenuCellLinkEntityHydrated
  to?: string
}

const FooterBlockMegamenuLink: React.FC<Props> = ({ link }) => {
  const { external: isExternal, badgeText, badgeColor, image } = link
  const hasBadge = Boolean(badgeText)
  const hasImage = Boolean(image)
  const isPageLink = link.type === "page"
  const { page } = usePage(link.pageId)
  let to = isPageLink ? page?.path : link.path

  if (!to) {
    to = "/"
  }

  let linkComponent = isExternal ? (
    <ExternalLink link={link} to={to} />
  ) : (
    <InternalLink link={link} to={to} />
  )

  let badgeComponent = null
  if (hasBadge) {
    badgeComponent = (
      <Badge
        size="xs"
        backgroundColor={badgeColor}
        textColor="white"
        borderRadius="md"
        textTransform="none"
      >
        {badgeText}
      </Badge>
    )
  }

  let imageComponent = null
  if (hasImage) {
    imageComponent = (
      <GatsbyLink to={to}>
        <Box mt={2}>
          <AspectRatio ratio={16 / 9} width="full" maxWidth={{ sm: "250px" }}>
            <Image src={image.path} borderRadius="lg" />
          </AspectRatio>
        </Box>
      </GatsbyLink>
    )
  }
  return (
    <>
      <HStack>
        {linkComponent}
        {badgeComponent}
      </HStack>
      {imageComponent}
    </>
  )
}

export default FooterBlockMegamenuLink

const InternalLink: React.FC<Props> = ({ link, to = "" }) => {
  const { label } = link
  const [isHovering, setIsHovering] = useState(false)

  const handleMouseEnter = () => {
    setIsHovering(true)
  }

  const handleMouseLeave = () => {
    setIsHovering(false)
  }

  return (
    <GatsbyLink
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      to={to}
      activeStyle={{
        textDecoration: "underline",
      }}
      style={{
        textDecoration: isHovering ? "underline" : "none",
      }}
    >
      {label}
    </GatsbyLink>
  )
}

const ExternalLink: React.FC<Props> = ({ link, to = "" }) => {
  const { label } = link
  return (
    <ChakraLink
      id={`mega-menu-link-${link.id}`}
      href={to}
      isExternal={true}
      onClick={() => {
        window.open(to, "newWindow")
      }}
      _hover={{
        textDecoration: "underline",
      }}
    >
      {label}
    </ChakraLink>
  )
}
